import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'src/makeStyles';
import { isArray, get } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { EMPTY_INFO_MARK } from '../../constants/consts';

const useStyles = makeStyles()((theme, props) => ({
  root: {
    fontWeight: props.fontWeight,
  },
  list: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: !props.noWrap && 'nowrap',
  },
  qualification: {
    fontWeight: 'normal',
    fontStyle: 'italic',
    fontSize: '13px',
  },
}));

const ListText = ({
  className,
  list,
  display,
  fontWeight,
  fieldToDisplay,
  emptyMark,
  listSeparator,
  limitedText,
  noWrap,
}) => {
  const { classes, cx } = useStyles({ fontWeight, noWrap });
  const listToDisplay = isArray(list) ? list : [list];

  if (listToDisplay?.length === 0) {
    return <span className={cx(classes.root, className)}>{EMPTY_INFO_MARK}</span>;
  }

  return (
    <>
      {display === 'list' && (
        <div className={cx(classes.root, { [classes.list]: limitedText }, className)}>
          {listToDisplay
            .map(item => (typeof item === 'object' ? get(item, fieldToDisplay) || emptyMark : item || emptyMark))
            .join(listSeparator)}
        </div>
      )}
      {display === 'column' && (
        <div className={cx(classes.root, className)}>
          {listToDisplay.map(item => (
            <div key={get(item, fieldToDisplay) || uuidv4()}>{get(item, fieldToDisplay) || emptyMark}</div>
          ))}
        </div>
      )}
    </>
  );
};

ListText.propTypes = {
  className: PropTypes.string,
  list: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  display: PropTypes.oneOf(['column', 'list']),
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fieldToDisplay: PropTypes.string,
  emptyMark: PropTypes.string,
  listSeparator: PropTypes.string,
  limitedText: PropTypes.bool,
  noWrap: PropTypes.bool,
};

ListText.defaultProps = {
  list: [],
  display: 'list',
  fontWeight: 'reqular',
  fieldToDisplay: 'name',
  emptyMark: EMPTY_INFO_MARK,
  listSeparator: ' / ',
  limitedText: true,
  noWrap: false,
};

export default memo(ListText);
